declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_structural_spread_other_foo extends $mol_object {
		test( ): ({ 
			'aaa': number,
		}) 
		field( ): ({ 
			'bbb': number,
		})  & ReturnType< $mol_view_tree2_to_js_test_ex_structural_spread_other_foo['test'] >
	}
	
}

//# sourceMappingURL=structural_spread_other.view.tree.d.ts.map